import axios from 'axios';
const API_URL = 'https://cava-don-carlos.herokuapp.com/api/v1/';

const searchProduct = (keyword: string, page: number) => {
    return axios.get(`${API_URL}shop/searchProducts/?keyword=${keyword}&page=${page}`);
}

const getProductCatalog = (page: number, limit: number, categoryFilter: string[]) => {
    return axios.post(`${API_URL}shop/products?page=${page}&limit=${limit}`, { categoryFilter });
}

const getFrontPageProducts = () => {
    return axios.get(`${API_URL}shop/frontPageProducts`);
}

const getProductById = (id: string, getFeatured = 0) => {
    return axios.get(`${API_URL}product/${id}?attachFeatured=${getFeatured}`);
}

export const API = {
    getProductById,
    getProductCatalog,
    getFrontPageProducts,
    searchProduct
}